import { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { BreakpointsEnum } from 'shared/constants/breakpoints'
import { useSettingsContext } from 'pages/settings/context/settingsContext'
import { WidgetChatProvider } from 'pages/settings/pages/widgetChat/context/widgetChatContext'
import { WidgetChat } from 'pages/settings/pages/widgetChat/ui/WidgetChat'

export const WidgetChatRouter = observer(() => {
  const { pageLayoutStore } = useSettingsContext()

  useEffect(() => {
    pageLayoutStore.setCustomCollapseWidth(BreakpointsEnum.L)
    return () => {
      pageLayoutStore.setCustomCollapseWidth(null)
    }
  }, [pageLayoutStore])

  return (
    <WidgetChatProvider>
      <Routes>
        <Route index element={<WidgetChat />} />
      </Routes>
    </WidgetChatProvider>
  )
})
